import { ModuleWithProviders, NgModule } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { PartnerState } from './store';
import { ApiPartnerService } from './services';


@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([ PartnerState ]),
  ],
  providers: [
    TransferState,
    ApiPartnerService
  ]
})
export class PartnerStateDataAccessModule {

  static forRoot(environment: Environment): ModuleWithProviders<PartnerStateDataAccessModule> {
    return {
      ngModule: PartnerStateDataAccessModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }

}
